import React from 'react';
import { Box, Typography } from '@mui/material';
import EngineeringOutlinedIcon from '@mui/icons-material/EngineeringOutlined';

const formatPlatform = (platform) => {
  if (!platform) return 'This';
  if (platform.toLowerCase() === 'codeforces') return 'Codeforces';
  if (platform.toLowerCase() === 'codechef') return 'CodeChef';
  if (platform.toLowerCase() === 'leetcode') return 'LeetCode';
  return platform.charAt(0).toUpperCase() + platform.slice(1);
};

const UnderConstruction = ({ platform }) => {
  const label = formatPlatform(platform);

  return (
    <Box
      sx={{
        minHeight: '45vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1,
      }}
    >
      <EngineeringOutlinedIcon color="action" sx={{ fontSize: 30 }} />
      <Typography variant="h6">{`${label} integration coming soon`}</Typography>
      <Typography variant="body2" color="text.secondary">
        We&apos;re working on adding support for this platform
      </Typography>
    </Box>
  );
};

export default UnderConstruction;
